import { AvcTasksTaskIdLogsGetRequest } from '@nativewaves/nw-cloud-sdk/content'
import { createRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@shared/components/ErrorHandling'
import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { JSON, Status } from 'domains/Workspaces/ContentFlows/AvcTasks/AvcTask'
import { Overview as Monitoring } from 'domains/Workspaces/ContentFlows/AvcTasks/AvcTask/Monitoring'
import { Panels } from 'domains/Workspaces/ContentFlows/AvcTasks/AvcTask/Task'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask/Structure'
import { avcTasksRoute } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/Routing'

export const avcTaskRoute = createRoute({
  getParentRoute: () => avcTasksRoute,
  path: DynamicRouteParameterWPrefix.AVC_TASK_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const avcTaskLayoutRoute = createRoute({
  getParentRoute: () => avcTaskRoute,
  id: 'avcTaskLayout',
  component: Structure,
  errorComponent: ErrorBoundary,
})

export const avcTaskConfigRoute = createRoute({
  getParentRoute: () => avcTaskLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: Panels,
})

export const avcTaskStatusRoute = createRoute({
  getParentRoute: () => avcTaskLayoutRoute,
  path: StaticRouteParameter.STATUS,
  component: Status,
})

type AvcTaskMonitoringSearch = Pick<
  AvcTasksTaskIdLogsGetRequest,
  'alertId' | 'alertCode' | 'types' | 'levels' | 'from' | 'to' | 'query'
>

export const avcTaskMonitoringRoute = createRoute({
  getParentRoute: () => avcTaskLayoutRoute,
  path: StaticRouteParameter.MONITORING,
  component: Monitoring,
  validateSearch: (search: Record<string, unknown>): AvcTaskMonitoringSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    if (search.types && typeof search.types === 'string' && !!search.types.length) {
      result.types = search.types
    }

    if (search.levels && typeof search.levels === 'string' && !!search.levels.length) {
      result.levels = search.levels
    }

    if (search.alertId && typeof search.alertId === 'string' && !!search.alertId.length) {
      result.alertId = search.alertId
    }

    if (search.alertCode && typeof search.alertCode === 'string' && !!search.alertCode.length) {
      result.alertCode = search.alertCode
    }

    if (search.from && typeof search.from === 'number' && !isNaN(search.from)) {
      result.from = search.from
    }

    if (search.to && typeof search.to === 'number' && !isNaN(search.to)) {
      result.to = search.to
    }
    return result satisfies AvcTaskMonitoringSearch
  },
})

export const avcTaskRawRoute = createRoute({
  getParentRoute: () => avcTaskLayoutRoute,
  path: StaticRouteParameter.RAW,
  component: JSON,
})
